<template>
  <div class="home">
    <div class="card search">
      <ul class="state">
        <li class="tit">状态：</li>
        <li @click=";(state = 0), getList()" :class="state === 0 ? 'active' : ''">全部</li>
        <li @click=";(state = 1), getList()" :class="state === 1 ? 'active' : ''">未开始</li>
        <li @click=";(state = 2), getList()" :class="state === 2 ? 'active' : ''">进行中</li>
        <li @click=";(state = 3), getList()" :class="state === 3 ? 'active' : ''">已结束</li>
      </ul>
      <ul>
        <li class="tit">类型：</li>
        <li @click=";(apply_type = 0), getList()" :class="apply_type === 0 ? 'active' : ''">全部</li>
        <li @click=";(apply_type = 1), getList()" :class="apply_type === 1 ? 'active' : ''">个人赛</li>
        <li @click=";(apply_type = 2), getList()" :class="apply_type === 2 ? 'active' : ''">团队赛</li>
      </ul>
    </div>
    <div class=" card content">
      <ul class="list" v-for="(item, index) in list" :key="index" @click="$router.push({ name: 'competition_detail', query: { id: item.id } })">
        <div class="list_left"><Img src="/face.jpg" /></div>
        <div class="list_right">
          <div class="tit">{{ item.name }}</div>
          <div class="des" v-html="item.introduce"></div>
          <div class="type">
            <span>{{ item.apply_type === 1 ? '个人赛' : '团队赛' }}</span>
            <span
              ><span>报名时间</span><span>{{ parseTime(item.start) }}</span> - <span>{{ parseTime(item.end) }}</span></span
            >
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/utils/index'

export default {
  data() {
    return {
      state: 0,
      apply_type: 0,
      loading: false,
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    parseTime,
    async getList() {
      this.loading = true
      const params = {
        uriCode: 'API006',
        pageIndex: 1,
        pageSize: 100,
        status: this.state,
        apply_type: this.apply_type
      }
      try {
        const res = await this.$fetch(params)
        this.list = res.list
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  box-sizing: border-box;
  background: #f0f3f7;
  height: calc(100vh - 50px);
  padding: 24px;
  .card {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 6px 32px;
  }
  .search {
    .state {
      border-bottom: 1px dashed #e9e9e9;
    }
    ul {
      line-height: 32px;
      font-size: 14px;
      display: flex;
      .tit {
        font-weight: 600;
        color: #000;
      }
      li {
        line-height: 32px;
        padding: 4px 14px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 15px 0;
        border-radius: 2px;
      }
      li.active {
        color: #0673fcff;
        background: #f1f7ff;
      }
      :nth-child(1) {
        cursor: default;
      }
    }
  }
  .content {
    height: calc(100vh - 251px);
    padding: 0;
    overflow-y: auto;
    margin-top: 24px;
    background: #f0f3f7;
    .list {
      background-color: #fff;
      box-sizing: border-box;
      padding: 32px;
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 15px;
      cursor: pointer;
      .list_left {
        width: 220px;
        height: 140px;
        img {
          width: 220px;
          height: 100%;
        }
      }
      .list_right {
        margin-left: 30px;
        .tit {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          line-height: 24px;
          margin: 10px 0 15px 0;
        }
        .des {
          font-size: 14px;
          line-height: 24px;
          color: #000000a6;
          height: 48px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .type {
          font-size: 14px;
          color: #00000073;
          :nth-child(1) {
            margin-left: 0;
          }
          span {
            margin: 12px 10px 0 10px;
          }
        }
      }
    }
  }
}
</style>
